import { signalStoreFeature, withState } from '@ngrx/signals';
import { UserInterface } from '../../app/shared/interfaces/global';
import { userInitializeState } from './user.state';
import { withUserComputed } from './user.computed';
import { withUserMethods } from './user.methods';

export function withUser() {
  return signalStoreFeature(
    withState<UserInterface>(userInitializeState),
    withUserComputed(),
    withUserMethods()
  )
}
